import React from "react";
import styled from "styled-components";
 
const Box = styled.div`
    padding: 0px 0px;
    background: #6B1514;
    //position: absolute;
    //bottom: 0;
    width: 100vw;
 
    @media (max-width: 1000px) {
        // padding: 70px 30px;
    }
`;

const Footer = () => {
    return (
        <Box>
            <div
                style={{
                    color: "#FFFFFF",
					background: "#6B1514",
                    textAlign: "center",
                    marginTop: "3px",
                    marginBottom: "3px",
                }}
            >
				Copyright &copy; Marcin Mączka (R-20250327)
            </div>
        </Box>
    );
};
export default Footer;